import { deserializeAddress } from './deserialize-address';
import { serializeAddress } from './serialize-address';
import {
  AddressRequestT,
  AddressResponseT,
  RegistrationAddressT,
} from '../../types';
import { TransformT } from '../../types/transform';

export const addressTransform: TransformT<RegistrationAddressT, AddressResponseT, AddressRequestT> = {
  deserialize: deserializeAddress,
  serialize: serializeAddress,
};
